export default __webpack_public_path__ + "static/chat-security-dark-049e8762e167a404d7e7a6f8d5704c32.png";